import { CdnBaseUrl } from '@deltek/specification-client/core/Utilities/urlUtils'
import { ElementType } from 'api/graphQL/reactiveVars/element'
import { CategoryPanel } from 'models/category'
import { FamilyNumberFormat } from 'models/projectSettings'
import { getFormattedFamilyNumber } from 'pages/ProjectsPage/projectUtils'

export const categoryBackgroundImage = (panelItem: CategoryPanel) => {
    return `url(${CdnBaseUrl}/specpoint/ae/categories/${panelItem.name
        .toLocaleLowerCase()
        .replace(/\s/g, '_')}.jpg)`
}

export const shortedCategoryData = (categoriesData: CategoryPanel[]) => {
    return categoriesData.slice().sort((a: CategoryPanel, b: CategoryPanel) => {
        if (a.name > b.name) {
            return 1
        } else if (a.name < b.name) {
            return -1
        }
        return 0
    })
}

// return updated element card title for redesigned element tree

export const updatedElementTitle = (
    elementType: string,
    title?: string,
    subtitle?: string,
    isBetaWorkspaceToggleEnabled?: boolean,
    selectedElementFormat?: string,
    famNumberFormat?: FamilyNumberFormat
) => {
    if (
        !isBetaWorkspaceToggleEnabled ||
        elementType === ElementType.PRODUCTTYPE
    )
        return title

    if (elementType === ElementType.PRODUCTFAMILY) {
        return `${getFormattedFamilyNumber(
            subtitle?.split(' ')?.[subtitle?.split(' ')?.length - 1] ?? '',
            famNumberFormat ?? FamilyNumberFormat.XXXXXX
        )} - ${title}`
    }
    
    if (elementType !== ElementType.PRODUCTTYPE) {
        return `${
            selectedElementFormat === 'DIVISIONS' && elementType === 'ASSEMBLY'
                ? 'DIVISION '
                : ''
        }${subtitle?.split(' ')?.[subtitle?.split(' ')?.length - 1]} - ${title}`
    }
    return title
}
